import React from 'react';
import { connect } from 'react-redux';

import { getLengthUnit } from '../../../reducers';
import MaterialsTable from './MaterialsTable';

export const MateiralsTableContainer = (props) => (
  <MaterialsTable {...props} />
);

const mapStateToProps = (state) => {
  const lengthUnit = getLengthUnit(state);
  return { lengthUnit };
}

export default connect(mapStateToProps)(MateiralsTableContainer);


// WEBPACK FOOTER //
// ./src/components/common/MaterialsTable/MaterialsTableContainer.jsx